/**
 * Simple keyframes polyfill for Mantine v7
 * Replaces the removed keyframes function from older Mantine versions
 */

type KeyframeStyles = Record<string, React.CSSProperties>;

let keyframeCounter = 0;
const injectedKeyframes = new Set<string>();

export function keyframes(styles: KeyframeStyles): string {
  const animationName = `mantine-keyframes-${keyframeCounter++}`;

  // Don't inject if already done
  if (injectedKeyframes.has(animationName)) {
    return animationName;
  }

  // Build the CSS keyframes string
  const cssKeyframes = Object.entries(styles)
    .map(([key, value]) => {
      const cssProps = Object.entries(value as Record<string, any>)
        .map(([prop, val]) => {
          // Convert camelCase to kebab-case
          const kebabProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();
          return `${kebabProp}: ${val};`;
        })
        .join(' ');
      return `${key} { ${cssProps} }`;
    })
    .join('\n  ');

  const keyframesRule = `@keyframes ${animationName} {\n  ${cssKeyframes}\n}`;

  // Inject into document
  if (typeof document !== 'undefined') {
    const styleId = `keyframes-${animationName}`;
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = keyframesRule;
      document.head.appendChild(style);
      injectedKeyframes.add(animationName);
    }
  }

  return animationName;
}
